import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import styles from '../formStyles.module.css';
import Button from '@/components/common/Button';
import Api from '@/api';
import EditPlateInfo from './EditPlateInfo';
import { useLayoutContext } from '@/context/LayoutContext';
import { useTranslations } from 'next-intl';
import { TRIGGERS } from '@/api/global';
import SignupCode from '../LoginModal/SignupCode';
import isValidMobile from '@/functions/isvalidMobile';
import PlateInput from '@/components/pages/home/HomeContent/HomeHero/PlateLookup/PlateInput';
import PlateBadge from '@/components/pages/home/HomeContent/CarSwitcher/PlateBadge';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
import useWindowDimensions from '@/functions/useWindowDimensions';
import { useRouter } from 'next/navigation';
import { useRouterPath } from '@/functions/routerPath';
import { Car, setState } from '@/commonTypes';

type Info = {
  name?: string;
  family?: string;
  mileage?: string | number;
  color?: string;
  colorId?: string | number;
  vin?: string;
  licensePlate?: string;
  brandId?: string | number;
  modelId: string | number;
  plate?: string;
  province?: { id?: number | string; title?: string } | null;
  model?: {
    id?: number | string;
    name?: string;
  };
  type?: number;
  EngineNumber?: string | number;
  chassisNumber?: string;
  provinceId?: string | number;
  cityId?: string;
  vehicleList?: { id?: string | number; title?: string; checked?: boolean }[];
  city?: { id?: string | number; title?: string };
  brand?: { id?: string | number; brand?: string };
  error: {
    name: boolean;
    family: boolean;
    model: boolean;
    mileage: boolean;
    color: boolean;
    colorId: boolean;
    vin: boolean;
    licensePlate: boolean;
    brandId: boolean;
    modelId: boolean;
    type: boolean;
    EngineNumber: boolean;
    chassisNumber: boolean;
    cityId: boolean;
  };
  messages: {
    name: string;
    family: string;
    model: string;
    mileage: string;
    color: string;
    colorId: string;
    vin: string;
    licensePlate: string;
    brandId: string;
    modelId: string;
    type: string;
    EngineNumber: string;
    chassisNumber: string;
    cityId: string;
  };
};
export type VehicleData = {
  id?: number | string;
  plate_number?: string;
  mileage?: string | number;
  vin?: string;
  chassis_number?: string;
  type?: number;

  user?: {
    first_name?: string;
    last_name?: string;
    id?: number | string;
  };

  model?: {
    id?: number | string;
    title?: string;
  };

  brand?: {
    id?: number | string;
    brand?: string;
  };

  color?: {
    id?: number | string;
    title?: string;
  };

  city?: {
    id?: number | string;
    province_id?: number | string;
    name?: string;
    province?: { id?: number; title?: string };
  };
  license_plate?: string;
  engine_number?: string | number;
};
type ModalData = Partial<Info> & {
  id?: number | string;
  users?: unknown[];
};

type AddSubuserModalProps = {
  data?: null | VehicleData;
  setData?: Dispatch<SetStateAction<Car | undefined>>;
  modalKey: string;
  setOpacity?: setState<boolean>;
};

export default function EditPlateModal({
  data = null,
  setData,
  modalKey,
  setOpacity,
}: AddSubuserModalProps) {
  const { setTrigger, userInfo, setUserInfo, setVisible, showError } = useLayoutContext();
  const { width } = useWindowDimensions();

  const tCommon = useTranslations('common');

  const [loading, setLoading] = useState<boolean>(false);
  const [active, setActive] = useState<number>(1);
  const router = useRouter();
  const routerPath = useRouterPath();

  const empty = {
    name: '',
    family: '',
    plate: 'ایران ۸۸ - ۴۱۴ ج ۸۷',
    // model: "",
    mileage: '',
    color: '',
    colorId: '',
    vin: '',
    licensePlate: '',
    brandId: '',
    brand: null,
    modelId: '',
    model: null,
    type: 1,
    EngineNumber: '',
    chassisNumber: '',
    provinceId: '',
    province: null,
    cityId: '',
    city: null,
    vehicleList: [
      { id: 1, title: 'سواری', checked: false },
      // { id: 2, title: "موتور" },
      { id: 3, title: 'ماشین سنگین', checked: false },
    ],
    error: {
      name: false,
      family: false,
      model: false,
      mileage: false,
      color: false,
      colorId: false,
      vin: false,
      licensePlate: false,
      brandId: false,
      modelId: false,
      type: false,
      EngineNumber: false,
      chassisNumber: false,
      cityId: false,
    },
    messages: {
      name: tCommon('requiredField'),
      family: tCommon('requiredField'),
      model: tCommon('requiredField'),
      mileage: tCommon('requiredField'),
      color: tCommon('requiredField'),
      colorId: tCommon('requiredField'),
      vin: tCommon('requiredField'),
      licensePlate: tCommon('requiredField'),
      brandId: tCommon('requiredField'),
      modelId: tCommon('requiredField'),
      type: tCommon('requiredField'),
      EngineNumber: tCommon('requiredField'),
      chassisNumber: tCommon('requiredField'),
      cityId: tCommon('requiredField'),
    },
  };
  const [info, setInfo] = useState<Info>(empty);

  useEffect(() => {
    if (!data) return;

    setInfo({
      ...info,
      ...data,
      name: data.user?.first_name ?? '',
      family: data.user?.last_name ?? '',
      mileage: data.mileage ?? '',
      model: data?.model,
      colorId: data.color?.id ?? '',
      provinceId: data.city?.province_id ?? '',
      province: data?.city?.province,
      vin: data.vin ?? '',
      brand: data.brand ?? '',
      modelId: data.model?.id ?? '',
      chassisNumber: data.chassis_number ?? '',
      type: data.type ?? 1,
      EngineNumber: data?.engine_number,
      vehicleList: info?.vehicleList?.map((x: any) => ({
        ...x,
        checked: data?.type === x?.id,
      })),
      plate: data.license_plate ?? '',
    });
  }, [data]);

  console.log('data==', data, info);

  const handleSubmit = () => {
    const hasError = checkError();

    if (hasError) return;

    let apiCall: Promise<unknown> | null = null;

    const params = {
      // brandId: info?.brandId,
      car_model_id: Number(info?.model?.id) || undefined,
      type: info?.vehicleList?.filter((x) => x.checked)?.[0]?.id,
      mileage: info?.mileage,
      color_id: Number(info?.colorId) || undefined,
      vin: info?.vin,
      city_id: info?.city?.id ? Number(info?.city?.id) : null,
      engine_number: info?.EngineNumber,
      chassi_number: info?.chassisNumber,
      id: Number(data?.id),
      sub_user_id: data?.user?.id,
    };

    apiCall = Api.plateUpdate(params);

    setLoading(true);

    apiCall
      ?.then(() => {
        setLoading(false);
        setData && setData(undefined);
        // setOpacity && setOpacity(true);
        setVisible(false);
        setTrigger(TRIGGERS.RERENDER);
        router.push(routerPath('/sub-users?garage=true'));
      })
      .catch((err: any) => {
        setLoading(false);

        showError(err);
      });
  };

  const checkError = (): boolean => {
    const dummy: Info = structuredClone(info);

    let result = false;
    let values: (keyof Pick<Info, 'name' | 'family'>)[] = [];

    values.forEach((key) => {
      if (!String(info[key] ?? '').trim()) {
        dummy.error[key] = true;
        result = true;
      }
    });

    setInfo(dummy);

    return result;
  };
  // const onKeyDown = (e: any) => {
  //   if (e.key === 'Enter') {
  //     handleSubmit();
  //   }
  // };
  // const onChange = (value: string | number, key: string) => {
  //   let valueIs = {
  //     ...info,
  //     [key]: value,
  //     error: {
  //       ...info?.error,
  //       [key]: false,
  //     },
  //   };
  //   // if (key == 'mobile') {
  //   //   valueIs.mobile = valueIs?.mobile?.startsWith('0')
  //   //     ? valueIs?.mobile.slice(1)
  //   //     : valueIs?.mobile;
  //   // }

  //   setInfo(valueIs);
  // };
  const handleResendCode = () => {};
  return (
    <div className={`${styles.container} ${styles.addressFormContainer}`}>
      <PlateBadge
        size={width && width > 560 ? 'xl' : width && width > 400 ? 'md' : 'sm'}
        type="large"
        car={{ plate: TransformPlateNumber(info?.plate) }}
        className={`${styles.plateBadge}`}
      />
      <EditPlateInfo info={info} setInfo={setInfo} modalKey={modalKey} />

      <Button
        onClick={handleSubmit}
        className="btn btn-primary w-full squareButton"
        wrapperStyle={`w-full`}
        loading={loading}
        showAnimation={false}
      >
        {tCommon('submit')}
      </Button>
    </div>
  );
}
